<template>
  <div class="cashflow-type-income card-box">
    <div class="title">
      <span>{{ titles.cardTitle }}</span>
    </div>

    <expense-progress :recommended-or-expected-label="titles.incomeProgress.recommendedLabel"
                      :up-to-now-label="titles.incomeProgress.actualsLabel"
                      :blocked="true"/>

    <predicted-category-sections :initially-expanded="false"
                                 :title="titles.categorySections.fixedIncome.mainTitle"
                                 :sectionsDisabled="true"/>

    <predicted-category-sections :initially-expanded="false"
                                 :title="titles.categorySections.variableIncome.mainTitle"
                                 :sectionsDisabled="true"/>
  </div>
</template>

<script>
import PredictedCategorySections from '../../../generic-components/cashflow-types/cashflow-types-base/PredictedCategorySections.vue';
import ExpenseProgress from '../../../generic-components/cashflow-types/cashflow-types-base/ExpenseProgress.vue';

export default {
  name: 'CashflowTypeIncome',
  components: {
    ExpenseProgress,
    PredictedCategorySections,
  },
  computed: {
    titles() {
      return {
        incomeProgress: {
          actualsLabel: 'נכנס עד עכשיו',
          recommendedLabel: 'סה״כ צפוי להיכנס',
        },
        categorySections: {
          fixedIncome: {
            actualsTitle: 'נכנס',
            recommendedTitle: 'צפוי להיכנס',
            mainTitle: 'פירוט הכנסות קבועות',
          },
          variableIncome: {
            actualsTitle: 'נכנס',
            mainTitle: 'פירוט הכנסות משתנות',
          },
        },
        cardTitle: 'הכנסות',
      };
    },
  },
};
</script>

<style lang="scss">
  @import '../../../../../../../../../../node_modules/base-ui/src/scss/riseup-colors';
  @import '../../../../../../../../../scss/mixins';

  .cashflow-type-income {
    @include cashflow-card;

    .title {
      @include cashflow-card-title;
    }

    .cashflow-type-color {
      color: $riseup_green;
    }
  }
</style>
